import React from "react";
import MobileScannerView from "../components/ui/Mobile-Scanner/MobileScannerView";

function Customer() {
  return <MobileScannerView />;
}

export default Customer;
